<template>
  <AsideContainer>
    <template>
      <!-- Google map -->
      <FieldGoogleMap
        :isFestivalYear="true"
        v-if="festival.address"
        :clickable="true"
        :address="festival.address"
        :iframeTitle="festival.name"
        @update:getGeoCodedPosition="$store.dispatch('getGeoCodedPosition', $event)"
      />
      <!-- 外部連結 -->
      <FieldOtherLinks
        :isFestivalYear="true"
        :links="festival.links"
        :titleImage="{
          src: 'title_other_link',
          alt: '外部連結',
          mode: 'medium',
          target: 'blank',
        }"
      />
    </template>
  </AsideContainer>
</template>

<script>
import AsideContainer from './AsideContainer'
import FieldGoogleMap from './FieldGoogleMap'
import FieldOtherLinks from './FieldOtherLinks'

export default {
  components: {
    AsideContainer,
    FieldGoogleMap,
    FieldOtherLinks,
  },
  computed: {
    festival() {
      return this.$store.getters.festival;
    },
  }
}
</script>